import {NgModule} from "@angular/core";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MatNativeDateModule, NativeDateAdapter,
} from "@angular/material/core";
import {DateTime} from "luxon";
import {parseAnyDate} from "@shared/helpers/date-time.helpers";

const locale = 'en-SG'

export const APP_MAT_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export class AppDateAdapter extends NativeDateAdapter {
  parse(value: any): Date | null {
    return parseAnyDate(value)
  }

  override format(date: Date, displayFormat: any): string {
    if (!date) return '';

    const dt = DateTime.fromJSDate(date);
    if (!dt.isValid) return '';

    if (displayFormat === 'input') {
      return dt.toFormat('dd/MM/yyyy');
    }

    return super.format(date, displayFormat);
  }
}

@NgModule({
  imports: [
    MatDatepickerModule,
    MatNativeDateModule,
  ],
  exports: [
    MatDatepickerModule,
    MatNativeDateModule,
  ],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: locale},
    {provide: DateAdapter, useClass: AppDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: APP_MAT_DATE_FORMATS},
  ]
})
export class MatDatepickerConfig {
}
